import { Component, OnInit, AfterViewInit, ElementRef, QueryList, ViewChildren, Input, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ApiService } from 'src/app/api/api.service';
import * as dayjs from 'dayjs';
import { AlertController, ModalController } from '@ionic/angular';
import { GlobalService } from 'src/app/api/global.service';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { an } from '@fullcalendar/core/internal-common';



@Component({
  selector: 'app-create',
  templateUrl: './create.page.html',
  styleUrls: ['./create.page.scss'],
})
export class CreatePage implements OnInit {
  @ViewChildren('inputField') inputFields: QueryList<ElementRef<HTMLInputElement>>;

  @ViewChild('bodyEditorDesc') bodyEditorDesc: any;
  private lastCursorIndexDesc: number | null = null;

  @ViewChild('bodyEditorCon') bodyEditorCon: any;
  private lastCursorIndexCon: number | null = null;

  @Input() creating_template = false;
  save_as_template = false;
  @Input() survey: any = {
    "guid": '',
    "title": "",
    "template_title": "",
    "description": "",
    "questions_arr": [],
  };
  today: any;
  items: MenuItem[];
  activeIndex: number = 0;
  dayjs: any = dayjs;

  companies: any;
  clients: any;
  clientFields = [
    // Identity
    { label: 'Display Name', value: 'client.display_name' },
    { label: 'First Name', value: 'client.first_name' },
    { label: 'Last Name', value: 'client.last_name' },
    { label: 'Middle Name', value: 'client.middle_name' },
    { label: 'Title (Mr/Mrs/Dr)', value: 'client.title' },
    { label: 'Suffix', value: 'client.suffix' },
    // Contact
    { label: 'Email', value: 'client.email' },
    { label: 'Phone', value: 'client.phone' },
    { label: 'Cell Phone', value: 'client.cell_phone' },
    { label: 'Alt Phone', value: 'client.alt_phone' },
    { label: 'Fax', value: 'client.fax' },
    { label: 'Website', value: 'client.website' },
    // Address
    { label: 'Address', value: 'client.address' },
    { label: 'City', value: 'client.city' },
    { label: 'Province / State', value: 'client.province' },
    { label: 'Postal / Zip Code', value: 'client.postal_code' },
    { label: 'Country', value: 'client.country' },
    // Personal
    { label: 'Gender', value: 'client.gender' },
    { label: 'Date of Birth', value: 'client.date_of_birth' },
    { label: 'Anniversary', value: 'client.anniversary' },
    { label: 'Spoken Language', value: 'client.spoken_language' },
    // Financial / Legal
    { label: 'SIN / SSN', value: 'client.sin' },
    { label: 'Fiscal Year End', value: 'client.fiscal_year_end' },
    { label: 'Custom ID', value: 'client.custom_id' },
    // Company fields
    { label: 'Company Name', value: 'company.name' },
    { label: 'Company Phone', value: 'company.phone' },
    { label: 'Company Address', value: 'company.address' },
    { label: 'Company City', value: 'company.city' },
    { label: 'Company Province / State', value: 'company.province' },
    { label: 'Company Postal / Zip', value: 'company.postal_code' },
    { label: 'Company Country', value: 'company.country' },
    { label: 'Corp Name', value: 'company.corp_name' },
    { label: 'Business Number', value: 'company.business_number' },
    { label: 'Company Fiscal Year End', value: 'company.fiscal_year_end' },
  ];

  newQuestion: any = {
    type: 'text',
    question_text: '',
    required: false,
    options: [],
    answer: '',
    conditional: false,
    conditional_guid: '',
    conditional_answer: '',
    client_field: '',
    write_back: false
  };

  // Track which question is being edited (null = adding new)
  editingQuestionGuid: string | null = null;
  lastWriteBack = false;

  selected_question: any = {
    type: 'text',
    question_text: '',
    required: false,
    options: [],
    answer: '',
    conditional: false,
    conditional_guid: '',
    conditional_answer: ''
  }




  constructor(private apiService: ApiService, public globalService: GlobalService, private modalController: ModalController, private alertController: AlertController) { }

  ngOnInit() {
    this.FormatData();
  }

  async FormatData() {
    
    if(this.survey.guid !== '') {
      if(!this.survey.questions) {
        await this.globalService.presentLoading("Loading Form...", 999999999);
        let data: any = await this.apiService.get(`surveys/${this.survey.guid}`);
        if(data.success && data.data && data.data[0]) {
          this.survey.questions = data.data[0].questions;
        }
        this.globalService.dismissLoading();  
      }
      console.log("Survey Questions", this.survey.questions);
      //We just want to load in the questions
    }
    // Parse questions if they come as a string from the API (for editing)
    if (this.survey && this.survey.questions && typeof this.survey.questions === 'string') {
      try {
        this.survey.questions_arr = JSON.parse(this.survey.questions);
      } catch (e) {
        console.error('Error parsing survey questions:', e);
        this.survey.questions_arr = [];
      }
    }
    // Ensure questions_arr is initialized
    if (!this.survey.questions_arr) {
      this.survey.questions_arr = [];
    }
    console.log(this.survey.questions_arr);


  }
  


  async Close() {
    const hasDirtyContent = this.survey.questions_arr?.length > 0
      || this.survey.title?.trim()
      || this.survey.description?.trim()
      || this.newQuestion.question_text?.trim()
      || this.newQuestion.options?.length > 0;

    if (hasDirtyContent) {
      const alert = await this.alertController.create({
        header: 'Are you sure?',
        message: 'You have unsaved changes. If you cancel now, your work will be lost.',
        buttons: [
          { text: 'Keep Editing', role: 'cancel' },
          { text: 'Discard', role: 'destructive', handler: () => this.modalController.dismiss(null) }
        ]
      });
      await alert.present();
    } else {
      this.modalController.dismiss(null);
    }
  }

  addOption() {
    this.newQuestion.options.push({ id: this.globalService.createGUID(), value: '' });
    setTimeout(() => {
      const fields = this.inputFields.toArray();
      if (fields.length > 0) {
        fields[fields.length - 1].nativeElement.focus();
      }
    });
  }

  addNewOption(event: KeyboardEvent) {
    this.addOption();
  }
  removeOption(_option) {
    console.log(_option);
    const index = this.newQuestion.options.findIndex((option) => option === _option);
    this.newQuestion.options.splice(index, 1);
  }

  addQuestion() {
    if (this.newQuestion.type === 'checkboxes') {
      console.log(this.newQuestion);
      this.newQuestion.answer = [];
      this.newQuestion.options.forEach(element => {
        this.newQuestion.answer.push(false);
      });
    }

    if (this.editingQuestionGuid) {
      // Update existing question
      const index = this.survey.questions_arr.findIndex(q => q.guid === this.editingQuestionGuid);
      if (index !== -1) {
        this.survey.questions_arr[index] = { ...this.newQuestion, guid: this.editingQuestionGuid };
      }
      this.editingQuestionGuid = null;
    } else {
      // Add new question
      this.newQuestion.guid = this.globalService.createGUID();
      this.survey.questions_arr.push({ ...this.newQuestion });
    }

    // Reset newQuestion for the next question
    this.newQuestion = {
      guid: '',
      type: 'text',
      question_text: '',
      required: false,
      options: [],
      answer: '',
      conditional: false,
      conditional_guid: '',
      conditional_answer: '',
      client_field: '',
      write_back: this.lastWriteBack
    };
    console.log(JSON.stringify(this.survey));
  }

  editQuestion(question: any) {
    // Load the question data into the form for editing
    this.editingQuestionGuid = question.guid;
    this.newQuestion = {
      guid: question.guid,
      type: question.type,
      question_text: question.question_text,
      required: question.required,
      options: question.options ? [...question.options.map(o => ({ ...o }))] : [],
      answer: question.answer,
      conditional: question.conditional,
      conditional_guid: question.conditional_guid,
      conditional_answer: question.conditional_answer,
      client_field: question.client_field || '',
      write_back: question.write_back || false
    };

    // Update selected_question if this is a conditional question
    if (this.newQuestion.conditional && this.newQuestion.conditional_guid) {
      this.conditionalQuestionChange();
    }
  }

  cancelEdit() {
    this.editingQuestionGuid = null;
    this.newQuestion = {
      guid: '',
      type: 'text',
      question_text: '',
      required: false,
      options: [],
      answer: '',
      conditional: false,
      conditional_guid: '',
      conditional_answer: '',
      client_field: '',
      write_back: this.lastWriteBack
    };
  }

  removeQuestion(_question) {
    const previousIndex = this.survey.questions_arr.findIndex((question) => question === _question);
    this.survey.questions_arr.splice(previousIndex, 1);
  }

  onQuestionDrop(event: CdkDragDrop<string[]>) {
    const previousIndex = this.survey.questions_arr.findIndex((question) => question === event.item.data);
    this.survey.questions_arr.splice(previousIndex, 1);
    this.survey.questions_arr.splice(event.currentIndex, 0, event.item.data);
  }

  trackById(index: number, option: any): any {
    return option.id;
  }

  onFieldSelected(field: string) {
    const current = this.newQuestion.question_text || '';
    const prefix = current.length > 0 && current[current.length - 1] !== ' ' ? ' ' : '';
    this.newQuestion.question_text = current + prefix + field + ' ';
  }

  onFieldSelectedCond(field: string) {
    const quill = this.bodyEditorCon?.quillEditor;
    if (quill) {
      const index = this.lastCursorIndexCon ?? quill.getLength();
      const charBefore = index > 0 ? quill.getText(index - 1, 1) : ' ';
      const charAfter = quill.getText(index, 1);
      const prefix = charBefore !== ' ' ? ' ' : '';
      const suffix = charAfter !== ' ' && charAfter !== '.' && charAfter !== '\n' && charAfter !== '' ? ' ' : '';
      const textToInsert = prefix + field + suffix;
      quill.insertText(index, textToInsert, 'user');
      const newIndex = index + textToInsert.length;
      quill.setSelection(newIndex, 0);
      this.lastCursorIndexCon = newIndex;
      // Sync ngModel
       this.newQuestion.conditional_answer = quill.root.innerHTML;
    } else {
       this.newQuestion.conditional_answer = (this.newQuestion.conditional_answer || '') + field;
    }

    this.newQuestion.conditional_answer = (this.newQuestion.conditional_answer || '') + field;
  }

  onFieldSelectedDesc(field: string) {
    const quill = this.bodyEditorDesc?.quillEditor;
    if (quill) {
      const index = this.lastCursorIndexDesc ?? quill.getLength();
      const charBefore = index > 0 ? quill.getText(index - 1, 1) : ' ';
      const charAfter = quill.getText(index, 1);
      const prefix = charBefore !== ' ' ? ' ' : '';
      const suffix = charAfter !== ' ' && charAfter !== '.' && charAfter !== '\n' && charAfter !== '' ? ' ' : '';
      const textToInsert = prefix + field + suffix;
      quill.insertText(index, textToInsert, 'user');
      const newIndex = index + textToInsert.length;
      quill.setSelection(newIndex, 0);
      this.lastCursorIndexDesc = newIndex;
      // Sync ngModel
      this.survey.description = quill.root.innerHTML;
    } else {
      this.survey.description = (this.survey.description || '') + field;
    }
  }

  onWriteBackChange() {
    this.lastWriteBack = this.newQuestion.write_back;
  }

  async conditionalQuestionChange() {
    console.log(this.newQuestion.conditional_guid);
    this.selected_question = this.survey.questions_arr[this.globalService.GetArrayIndex(this.survey.questions_arr, this.newQuestion.conditional_guid)];
  }

  conditionalAnswerFufilled(question) {
    if (question.conditional == false) return true;
    return this.survey.questions_arr[this.globalService.GetArrayIndex(this.survey.questions_arr, question.conditional_guid)].answer == question.conditional_answer;
  }

  async SaveAsNew() {
    const alert = await this.alertController.create({
      header: 'Save as New Form',
      inputs: [
        {
          name: 'template_title',
          type: 'text',
          placeholder: 'Enter a title for the new Form',
          value: this.survey.template_title || '',
        },
      ],
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Save',
          handler: (data) => {
            if (!data.template_title?.trim()) return false;
            this.survey.guid = '';
            this.survey.template_title = data.template_title.trim();
            this.Create();
          },
        },
      ],
    });
    await alert.present();
  }

  async Create() {
    this.survey.questions = JSON.stringify(this.survey.questions_arr);
    if (this.creating_template || this.save_as_template) {
      let data: any;
      // Check if we're updating an existing survey or creating a new one
      if (this.survey.guid && this.survey.guid !== '') {
        data = await this.apiService.put(`surveys/${this.survey.guid}`, this.survey);
      } else {
        data = await this.apiService.post('surveys/templates', this.survey);
      }
      if (data.success && data.data && data.data[0]) {
        this.survey = data.data[0];
      }
      console.log(this.survey);
    }
    this.modalController.dismiss(this.survey);
  }




}
